// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e72ad538","977":"07792a9e"}[chunkId] + ".chunk.js";
};